import React, { useState } from "react";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import UIRadio from "components/ui/UIRadio";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import { useModel, useRoute, useBCMSModal, useParams, useBCMSContext, BCMSRecord } from "@bcm-dev/bcms-vite";
import Classes, { Card } from "model";

import "./styles.css";

/**
 * @function RecognizeTransactionsView
 * @return {React.Component}
 * @exported true
 * @description The main component for RecognizeTransactionsView
 */
export default function RecognizeTransactionsView(props) {
  const { branding } = useModel();
  const navigate = useRoute();
  const controller = useBCMSContext();
  const { open: openModal } = useBCMSModal();

  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const debitBranding = branding.options.loststolen_debit_chw23;
  const creditBranding = branding.options.loststolen_credit_chw23;
  // Values that the debit and credit branding options support
  const withIssuance = "self-service with digital issuance";
  const withoutIssuance = "self-service without digital issuance";

  const [ state, setState ] = useState("I recognize all my transactions");
  const changeState = (value, label) => setState(label);

  const cancelBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);
  const nextBtn = evt => {
    const optionToUse = card.type === "debit" ? debitBranding : creditBranding;

    if(state === "I recognize all my transactions") {
      if(optionToUse === withIssuance) { navigate(`/home/reportloststolen/sentcardtoaddress/${ cardID }`); }
      else {
        BCMSRecord.batch([
          Card.update({ ...card.record, isOn: false })
        ], controller, Classes);

        navigate(`/home/reportloststolen/digitalissuanceconfirm/${ cardID }`);
      }
    }
    else {
      if(optionToUse === withIssuance) { navigate(`/home/reportloststolen/sentcardtoaddress/${ cardID }`); }
      else { openModal("TurnCardOffModal", { route: `/home/reportloststolen/digitalissuanceconfirm/${ cardID }/cardIsStolen/transactionsIDidNotMake` }); }
    }
  }

  return (
    <div className="recognize-transactions-view">
      <div className="content-container">
        <p>Do you recognize all the transactions on your card?</p>
      </div>
      <FormContainer>
        <FormRow>
          <UIRadio label="I recognize all my transactions" name="option" value={ state === "I recognize all my transactions" } onChange={ changeState } />
        </FormRow>
        <FormRow>
          <UIRadio label="I see transaction(s) that I did not make" name="option" value={ state === "I see transaction(s) that I did not make" } onChange={ changeState } />
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Next" onClick={ nextBtn } />
          <UICancelButton text="Cancel" onClick={ cancelBtn } />
        </FormButtonContainer>
      </FormContainer>
    </div>
  );
}